// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"864df346","223":"a77f7353","368":"63a0bee1","453":"ae9c510e","987":"93ea7f1c"}[chunkId] + ".chunk.js";
};